import React, { Component } from 'react';
import { Menu, Dropdown, Button } from 'antd';
import classNames from 'classnames';
import NewImage from './NewImage';
import { showModal, MODAL_PRESENT_ITEM_DELETE, MODAL_VIDE_INFO } from '../../../../../../modules/modals';
import { connect } from 'react-redux'
import history from '../../../../../../history';


class Actions extends Component {
  componentDidMount(){
    // if(!localStorage.getItem('view_video_info_slider_start')){
    //   localStorage.setItem('view_video_info_slider_start', 1)
    //   this.props.showModal({
    //     modalType : MODAL_VIDE_INFO,
    //     modalProps : {
    //       titleModal: 'txtTitleVideoInfoPresentationStart',
    //       messageModal: 'txtMessageVideoInfoPresentationStart',
    //       videoUrl: '/images/video_info/how_to_convert_to_pics.mp4'
    //     }
    //   })
    // }
  }
  render() {
    const {slide, items, item, session_id, selected_slides, onSelectedSlide} = this.props;

    const count_imgs = items.filter(i => i.type == 'image').length;

    return (
      <div className="Actions">
        <Dropdown overlay={() => (<Menu>
          <Menu.Item>
            <NewImage loadFileSpiner={this.props.loadFileSpiner} session_id={session_id} countImgs={count_imgs} />
          </Menu.Item>
        </Menu>)} placement="bottomLeft">
          <div className={classNames("new-slide", {disabled: session_id != 0})}><i className="fas fa-plus"></i></div>
        </Dropdown>
        <div className={classNames("delete-slide", {disabled: !selected_slides.length})} onClick={() => {
          if(!selected_slides.length){
            return
          }
          this.props.showModal({
            modalType : MODAL_PRESENT_ITEM_DELETE,
            modalProps : {
              ids: selected_slides,
              onSelectedSlide: onSelectedSlide
            }
          });
        }}><i className="fas fa-minus"></i></div>
        {/* <div className={classNames("delete-slide", {disabled: !items.length || session_id != 0})} onClick={() => {
          if(items.length && session_id == 0){
            history.push('/sliders_start/' + item.id)
          }
        }}><i className="fas fa-play"></i></div> */}
        {/* <div className={classNames("delete-slide")} onClick={() => {
          this.props.showModal({
            modalType : MODAL_VIDE_INFO,
            modalProps : {
              titleModal: 'txtTitleVideoInfoPresentationStart',
              messageModal: 'txtMessageVideoInfoPresentationStart',
              videoUrl: '/images/video_info/how_to_convert_to_pics.mp4'
            }
          })
        }}><i className="fas fa-question"></i></div> */}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  slide: state.slider.slide,
  items: state.slider.items,
  item: state.slider.item,
})

const mapDispatchToProps = {
  showModal
}

export default connect(mapStateToProps, mapDispatchToProps)(Actions)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Slider/components/Sliders/components/Actions/index.jsx